<template>
    <Breadcrumbs main="Materials" title="Orders" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <orders-table />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const OrdersTable = defineAsyncComponent(() => import("@/components/materials/orders/orders-table.vue"))
</script>